import { api } from 'src/api/api-client.config';
import { useMutation } from '@tanstack/react-query';

const uploadUsers = ({
  id,
  bodyFormData,
}: {
  id: number;
  bodyFormData: FormData;
}) =>
  api.post(`/admin/pickems/${id}/upload-users`, bodyFormData, {
    headers: { 'Content-Type': 'multipart/form-data' },
  });

export const useUploadParticipantsMutation = ({
  pickemId,
}: {
  pickemId: number;
}) => {
  return useMutation({
    mutationKey: ['uploadParticipants', pickemId],
    mutationFn: ({ bodyFormData }: { bodyFormData: FormData }) =>
      uploadUsers({ id: pickemId, bodyFormData }),
  });
};
